import ExpandablePanel from './ExpandablePanel'
import Label from './Label'
import Body from './Body'

ExpandablePanel.Label = Label
ExpandablePanel.Body = Body

export default ExpandablePanel
